import http from '../http'

export default {
    /**
     * Consulta la direccion
     * @param {int} usuario
     * @returns {Promise}
     */
    get(usuario) {
        return http.get(`usuarios/${usuario}/direcciones`)
    },

    /**
     * Crea la direccion
     * @param {int} usuario
     * @param {Object} payload
     * @returns {Promise}
     */
    create(usuario, payload) {
        return http.post(`usuarios/${usuario}/direcciones`, payload)
    },

    /**
     * Actualiza la direccion
     * @param {int} usuario
     * @param {Object} payload
     * @returns {Promise}
     */
    update(usuario, payload) {
        return http.put(`usuarios/${usuario}/direcciones`, payload)
    },
}